import { Mutation, Query } from "react-apollo"
import React from "react"
import Container from "./Container"
import gql from "graphql-tag"
import {
  assignIds,
  removeIds,
  updateComponent,
  deleteComponent,
  addComponent,
  moveComponent,
} from "./helpers"

class EditHomePage extends React.Component {
  constructor(props) {
    super(props)

    let components = assignIds(props.data.page.components)

    this.state = {
      originalComponents: components,
      components: components,
      hasEdited: false,
    }
  }

  editComponents = (editFn, args) => {
    this.setState(({ components }) => ({
      components: editFn(components, ...args),
      hasEdited: true,
    }))
  }

  updateComponent = (...args) => {
    this.editComponents(updateComponent, args)
  }

  deleteComponent = (...args) => {
    this.editComponents(deleteComponent, args)
  }

  moveComponent = (...args) => {
    this.editComponents(moveComponent, args)
  }

  addComponent = (...args) => {
    this.editComponents(addComponent, args)
  }

  reset = () => {
    this.setState(({ originalComponents }) => ({
      components: originalComponents,
      hasEdited: false,
    }))
  }

  submit = () => {
    this.props
      .updateHomePage(this.state.components)
      .then(({ data }) => {
        let { payload, message } = data.updatePage

        if (payload !== "success") {
          alert(message)
          return
        } else {
          this.setState(({ components }) => ({
            hasEdited: false,
            originalComponents: components,
          }))
        }
      })
      .catch((err) => {
        console.log("Error updating page: ", err.message)
        alert("An error occurred while processing your request.")
      })
  }

  render = () => {
    let { components, hasEdited } = this.state
    return (
      <div>
        <div id="edit-home-page-header">
          <h3>Edit Dashboard</h3>
          <div className="button-container">
            {hasEdited && (
              <div className="button-item cancel" onClick={() => this.reset()}>
                Undo Changes
              </div>
            )}
            {hasEdited && (
              <div
                className="button-item submit"
                onClick={() => this.submit()}
              >
                Submit Changes
              </div>
            )}
          </div>
        </div>
        <Container
          components={components}
          updateComponent={this.updateComponent}
          deleteComponent={this.deleteComponent}
          moveComponent={this.moveComponent}
          addComponent={this.addComponent}
        />
      </div>
    )
  }
}

const HomePageQuery = gql`
  query HOME_PAGE {
    page(slug: "/") {
      ... on StaticPage {
        name
        url
        meta {
          title
          description
          image
        }
        components
      }
    }
  }
`

const EditHomePageMutation = gql`
  mutation EDIT_HOME_PAGE($name: String!, $url: String!, $components: [json]!) {
    updatePage(name: $name, url: $url, components: $components, slug: "/") {
      payload
      message
    }
  }
`

const EditHomePageWithData = (props) => (
  <Query query={HomePageQuery} fetchPolicy="network-only">
    {({ loading, error, data }) => {
      if (loading) return "Loading..."
      if (error) return `Error! ${error.message}`

      return (
        <Mutation
          mutation={EditHomePageMutation}
          refetchQueries={[{ query: HomePageQuery }]}
        >
          {(mutate) => {
            const updateHomePage = (components) =>
              mutate({
                variables: {
                  ...data.page,
                  components: removeIds(components),
                },
              })

            return (
              <EditHomePage
                {...props}
                updateHomePage={updateHomePage}
                data={data}
              />
            )
          }}
        </Mutation>
      )
    }}
  </Query>
)

export default EditHomePageWithData
